<template>
    <div>
    <div class="row text-center" 
    :class="[
      {'justify-content-end': right},
      {'justify-content-start': left},
      {'justify-content-center':!right && !left}
    ]">
      <beat-loader :size="size" :loading="loading" :color="color"></beat-loader>
    </div>
    <slot v-if="!loading"></slot>
    </div>
</template>

<script>

import BeatLoader from 'vue-spinner/src/BeatLoader';

export default {
    name:'loader',
    components:{
        BeatLoader
    },
    props:{
        size:{type:String},
        loading:{type:Boolean,required:true},
        right:{type:Boolean,required:false,default:false},
        left:{typ:Boolean,required:false,default:false}
    },
    data(){
        return{
            color:'#185e9b'
        }
    }
}
</script>

<style>

</style>